import React, { useState } from "react";
import { service_insurance } from "../../../data/servicesData";

const LandlordsTabPage = () => {
  const [data] = useState(service_insurance?.landlords || {});

  return (
    <div className="text-left space-y-6">
      <div className="space-y-2">
        {data.overview.map((item, index) => (
          <div key={index}>
            <span>{item}</span>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.title1}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.items1.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.title2}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.items2.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LandlordsTabPage;
